import React from 'react'
import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-space-black flex items-center justify-center p-8">
      <div className="text-center space-y-8 max-w-2xl">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', duration: 0.8 }}
          className="text-9xl font-orbitron text-electric-cyan"
        >
          404
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="space-y-4"
        >
          <h1 className="text-4xl font-orbitron text-light-gray">
            Lost in Space
          </h1>
          <p className="text-xl text-light-gray/80">
            This page seems to have drifted beyond our constellation. 
            The cosmic coordinates you're looking for don't exist in our universe.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="space-y-4"
        >
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/')}
              className="flex items-center justify-center gap-2 bg-electric-cyan text-space-black px-6 py-3 rounded-lg font-semibold hover:bg-electric-cyan/80 transition-colors"
            >
              <Home size={20} />
              Return to Base
            </button>
            
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center gap-2 border border-electric-cyan text-electric-cyan px-6 py-3 rounded-lg font-semibold hover:bg-electric-cyan/10 transition-colors"
            >
              <ArrowLeft size={20} />
              Go Back
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="text-sm text-light-gray/60"
        >
          Or use the navigation to explore my constellation of projects and experiences.
        </motion.div>
      </div>
    </div>
  )
}

export default NotFoundPage